export type AdventurePushStatus = "interested" | "joined";

export const getAdventureStatusNotificationType = (status: string | null | undefined) => {
  if (status === "joined") return "adventure_joined";
  if (status === "interested") return "adventure_interested";
  return null;
};

export const buildAdventureStatusNotificationBody = ({
  actorName,
  adventureTitle,
  status,
}: {
  actorName?: string | null;
  adventureTitle?: string | null;
  status: AdventurePushStatus;
}) => {
  const name = actorName?.trim() || "Someone";
  const title = adventureTitle?.trim();
  const suffix = title ? `: ${title}` : "";

  return status === "joined"
    ? `${name} joined your Activity${suffix}`
    : `${name} is interested in your Activity${suffix}`;
};
